import { dateFormator, DirFormat } from "../utils/dateUtils";

const DateInputBox = ({ side, from, to, onClick, borderActive = true, format, ...props }) => {
  const date = side === "from" ? from : to;

  const isActive = (() => {
    if (from && to) return side === "to";
    if (from && !to) return side === "from";
    return false;
  })();

  const classes = [
    "date-input-box body-m-semibold",
    onClick ? "date-input-box--clickable" : "",
    !date ? "date-input-box--placeholder" : "",
    isActive && borderActive ? "date-input-box--active" : "",
  ].filter(Boolean).join(" ");

  return (
    <span
      onClick={onClick}
      className={classes}
      style={props.style}
    >
      {format === "month-year" ? DirFormat(date || new Date()) : dateFormator(date || new Date(), { type: "input-format" }, "-")}
    </span>
  );
};

const DateSeparator = () => {
  return <span className="date-separator">-</span>;
};

export { DateInputBox, DateSeparator };